import React, { useEffect, useState } from "react";
import { useBookingAtom } from "../../Utilities/clubStore";
import { checkNullAndUndefined } from "../../Utilities/utils";
import moment from "moment";
import dummyProfileNew from "../../widgets/bookingWidget/bookingModal/images/dummyProfileNew.png";

const BookingTimeSlot = ({
    index,
    selectedButton,
    getSlotValue,
    slot,
    slots,
    timezone,
    handleButtonClick,
    setSelectedSlotIdx,
    time
}: any) => {
    const [bookingAtom, setBookingAtom] = useBookingAtom();
    const [showProfileImages, setShowProfileImages] = useState([]);
    console.log("showProfileImages", showProfileImages);
    const [otherOpenMatchesCount, setOtherOpenMatchesCount] = useState(0);
    console.log("otherOpenMatchesCount", otherOpenMatchesCount);

    useEffect(() => {
        const timeValue = getSlotValue(slot, true);
        if (!checkNullAndUndefined(timeValue) && timeValue !== "") {
            const myArray = timeValue.split(",");
            console.log("myArray", myArray);
            if (
                slots?.reservedBookings &&
                slots?.reservedBookings?.length > 0
            ) {
                const slotValue = myArray[0];
                const matchingBookings = getBookingsByStartTime(
                    slotValue,
                    slots?.reservedBookings
                );
                if (matchingBookings && matchingBookings?.length > 0) {
                    const images =
                        getPlayerImagesFromAllItems(matchingBookings);
                    if (images && images?.length > 0) {
                        setShowProfileImages(images);
                        setOtherOpenMatchesCount(images?.length);
                    } else {
                        setOtherOpenMatchesCount(0);
                    }
                } else {
                    setOtherOpenMatchesCount(0);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getPlayerImagesFromAllItems = (data: any) => {
        if (!Array.isArray(data) || data.length === 0) return [];

        const imageUrls: any = [];

        data.forEach((item) => {
            const playersObj = item?.open_match?.players || {};

            Object.values(playersObj)
                .filter((player) => player !== "")
                .forEach((player: any) => {
                    try {
                        if (typeof player === "string") {
                            const fixed = player.replace(/'/g, '"');
                            const parsed = JSON.parse(fixed);
                            imageUrls.push(parsed.profilePic ?? "");
                        } else {
                            imageUrls.push(player.profilePic ?? "");
                        }
                    } catch (e) {
                        imageUrls.push("");
                    }
                });
        });

        return imageUrls;
    };

    function getBookingsByStartTime(timeHHmm: any, reservedBookings = []) {
        return reservedBookings.filter((booking: any) => {
            const bookingTime = moment
                .tz(booking?.start_datetime, timezone)
                .format("HH:mm");
            return bookingTime === timeHHmm;
        });
    }
    return (
        <div key={index} className="relative">
            <button
                id={`slot-${index}`}
                className={
                    selectedButton === getSlotValue(slot, false)
                        ? "bg-secondary text-white text-[13px] border border-secondary rounded-full px-3 py-1 min-w-[63px] sm:min-h-[29px] flex items-center justify-center uppercase hover:opacity-80 transform duration-200"
                        : "bg-white text-secondary text-[13px] border border-secondary rounded-full px-3 py-1 min-w-[63px] sm:min-h-[29px] flex items-center justify-center uppercase hover:bg-primary hover:text-secondary transform duration-200"
                }
                onClick={() => {
                    handleButtonClick(time);
                    setSelectedSlotIdx(index);
                    setBookingAtom({
                        ...bookingAtom,
                        startTime: getSlotValue(time, true),
                        selectedSlot: getSlotValue(time, true)
                    });
                }}
                style={{
                    padding: "6px 10px",
                    width: 80
                }}
            >
                {getSlotValue(slot, true)}
            </button>
            <div className="flex absolute -top-2 right-0 items-center">
                {showProfileImages.slice(0, 4).map((uri, index) => (
                    <img
                        alt="profile"
                        key={index}
                        src={uri && uri !== "" ? uri : dummyProfileNew}
                        className="min-w-4 max-w-4 h-4 rounded-full border border-gray-400 -ml-2"
                    />
                ))}
                {otherOpenMatchesCount > 4 && (
                    <div className="-ml-2">
                        <p
                            className="bg-white text-secondary font-medium border border-gray-400 rounded-full text-[10px] p-0.5 w-3.5 h-3.5 flex justify-center items-center"
                            style={{
                                fontSize: otherOpenMatchesCount - 4 > 9 ? 8 : 9
                            }}
                        >
                            +{otherOpenMatchesCount - 4}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BookingTimeSlot;
